import { useEffect, useState } from "react";
/**
 * Custom hook to track if the user has scrolled a certain distance.
 * @param distance - The distance to scroll before triggering the hook.
 * @param active - Whether the hook is active.
 */
export const useScrolled = ({ distance, active, }) => {
    const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        if (!active || scrolled)
            return;
        const startY = window.scrollY;
        const handleScroll = () => {
            if (Math.abs(window.scrollY - startY) >= distance) {
                setScrolled(true);
                window.removeEventListener("scroll", handleScroll);
            }
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [active, distance, scrolled]);
    return scrolled;
};
